// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 329) return "modules/modern_329-329.js?cacheBreaker=e37342762587b4e4ced6";
	// return url for filenames based on template
	return undefined;
};